import { render, staticRenderFns } from "./CtasBancosProveedoresList.vue?vue&type=template&id=c5f4b2bc&"
import script from "./CtasBancosProveedoresList.vue?vue&type=script&lang=js&"
export * from "./CtasBancosProveedoresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports